module.exports = __webpack_public_path__ + "assets/images/base.94bb682102cfa4aedc6f463fa56c8f19.svg";